module.exports = __webpack_public_path__ + "img/gerenciador-contas-youtube-icon.f044958b.svg";